<ntap-view-window
  #childWindow
  target="mjesto_item_readonly"
  [contentTemplate]="viewWindowContent"
>
  <ng-template #viewWindowContent let-defaultTemplate>
    <ng-container ntapDynamicFormProvider>
      <ntap-prime-popupview appendTo="body" [modal]="true">
        <ng-container *ngTemplateOutlet="defaultTemplate"></ng-container>
      </ntap-prime-popupview>
    </ng-container>
  </ng-template>
</ntap-view-window>
<p-button
  [hidden]="true"
  ntapDebounceClick
  label="Pregledaj"
  (onClick)="executeAction($event)"
></p-button>
